import _ from 'lodash'

/**
 * Class responsible for a bit cleaner and more verbose console printing of axios error objects
 */
class AxiosSetup {
    /**
   * Error handler itself
   * @param {*} error
   * @return {Promise}
   */
    handleError(error) {
        const response = _.get(error, 'response', null)
        const request = _.get(error, 'request', null)
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        if (response) {
            console.groupCollapsed(`${response.status} - ${_.get(response, 'data.message', '< no message >')}`)
            console.error(response)
        } else if (request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.groupCollapsed('No response')
            console.error(error.request)
        } else {
            // Something happened in setting up the request that triggered an Error
            console.groupCollapsed('Other error message')
            console.error('Error', error.message)
        }
        console.log(error.config)
        console.groupEnd()

        return Promise.reject(error)
    }
}

export default new AxiosSetup()
